import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import Lightbox from 'react-image-lightbox';
import 'swiper/swiper.min.css';
import 'react-image-lightbox/style.css';
import './ImageSlider.css';
import Skeleton from 'react-loading-skeleton';
SwiperCore.use([Navigation]);

const ImageSlider = ({ images, isLoading }) => {
    const [photoIndex, setPhotoIndex] = useState(Math.floor(images.length / 2));
    const [isOpen, setIsOpen] = useState(false);
    const [loadedImages, setLoadedImages] = useState([]);
    const [showSlider, setShowSlider] = useState(false);

    useEffect(() => {
        const loadImages = async () => {
            const promises = images.map((image) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.src = `${image.Url}?width=${image.Width}&height=${image.Height}&quality=${image.Quality}&scale=both&mode=crop`;
                    img.alt = `${image.Alt}`;
                    img.onload = () => resolve(image.Url);
                    img.onerror = reject;
                });
            });

            try {
                const loaded = await Promise.all(promises);
                setLoadedImages(loaded);
            } catch (error) {
                console.error('One or more images failed to load', error);
            }
        };

        loadImages();
    }, [images]);

    useEffect(() => {
        setTimeout(() => {
            setShowSlider(true);
        }, 1300);
    }, [isLoading]);


    const handleSlideClick = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
    };

    const handleViewAllClick = () => {
        setPhotoIndex(0);
        setIsOpen(true);
    };

    if (isLoading ){
        return(
            <div className="tw-w-full tw-overflow-hidden">
                <div className="tw-bg-slate-200 tw-h-[600px]" >
                    
                </div>
            </div>
        );
    }

    return (
        <div className={`tw-relative  ${showSlider ? '' : 'tw-bg-slate-200'}`}>
            <div className={` ${showSlider ? 'opacity-100' : 'opacity-0'}`}>
                {(images.length) && (
                    <Swiper

                        key={loadedImages.join('_')}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} // Add arrows navigation
                        spaceBetween={3}
                        centeredSlides={true}
                        loop={true}
                        centeredSlidesBounds={true}
                        //initialSlide={photoIndex}
                        //onSlideChange={({ activeIndex }) => setPhotoIndex(activeIndex)}
                        breakpoints={{
                            // when window width is >= 640px
                            640: {
                                slidesPerView: 2.4,
                            },
                            // when window width is <= 639px
                            0: {
                                slidesPerView: 1,
                            }
                        }}
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={image.Id} style={{ padding: '0 2px' }}>
                                <img 
                                    src={`${image.Url}?width=${image.Width}&height=${image.Height}&quality=${image.Quality}&scale=both&mode=crop`} 
                                    width={`${image.Width}`} 
                                    height={`${image.Height}`}
                                    className={`tw-h-auto tw-max-w-full tw-block`}
                                    onClick={() => handleSlideClick(index)}
                                 />
                                {/* <div style={{
                                        backgroundImage: `url(${image.Url}?width=${image.Width}&height=${image.Height}&quality=${image.Quality}&scale=both&mode=crop)`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        height: '590px',
                                        width: '100%',
                                        borderRadius: '1px' // optional, for styling
                                    }}
                                    onClick={() => handleSlideClick(index)}
                                > 
                                </div>*/}
                            </SwiperSlide>
                        ))}
                        <div className="swiper-button-next round"></div>
                        <div className="swiper-button-prev round"></div>
                    </Swiper>
                    
                )}

                <button onClick={handleViewAllClick} className="view-all-photos">View all photos ({images.length})</button>

                {isOpen && (
                    <Lightbox
                        mainSrc={images[photoIndex % images.length].Url}
                        nextSrc={images[(photoIndex + 1) % images.length].Url}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length].Url}
                        onCloseRequest={() => setIsOpen(false)}
                        onMovePrevRequest={() =>
                            setPhotoIndex((photoIndex + images.length - 1) % images.length)
                        }
                        onMoveNextRequest={() =>
                            setPhotoIndex((photoIndex + 1) % images.length)
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default ImageSlider;